import React from 'react';
import loadable from '@loadable/component';

export default ({ activeStep, partiallyCompleted }) => {
	const Component = loadable(() => import('./OnboardingProgress'));
	return <Component activeStep={activeStep} partiallyCompleted={partiallyCompleted} />;
};
